import Component from '../core/Component'
import Flickity from 'flickity'
import debounce from 'lodash/debounce'
import Scroll from '../services/Scroll'
import { CMS } from '../core/config'

const STATES = {
    FLICKITY_ACTIVE: 'is-flickity-active',
    IS_PREV_VISIBLE: 'is-prev-visible',
    IS_NEXT_VISIBLE: 'is-next-visible'
}

export const EMITS = {
    SELECTED: 'selected',
    RESIZE_END: 'resize-end'
}

export default class Slider extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            slider: null,
            fcktySlider: null, //slouzi jen k vypoctu, kdyz je flickity aktivovany, nepouzivat v html
            prevs: [],
            nexts: [],
            // items: []
        }

        this.index = null
        this.flickity = null

        this.handleResizeEnd = () =>{
            this.check()
            this.emit(EMITS.RESIZE_END)
        }
        this.resizeEnd = debounce(this.handleResizeEnd, 200)
    }

    prepare() {
        if (CMS) {
            return
        }

        this.check()

        Scroll.on('resize-x', this.handleResize)
    }

    destroy() {
        Scroll.off('resize-x', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    handleFlickitySelect = index => {
        this.index = index
        this.emit(EMITS.SELECTED, { index })
        this.checkPrevNext()
    }

    check() {
        const element = this.flickity ? this.ref.fcktySlider : this.ref.slider
        if (element.scrollWidth > element.offsetWidth) {
            this.createFlickity()
        } else {
            this.destroyFlickity()
        }
    }

    createFlickity() {
        if (this.flickity) {
            return
        }
        this.flickity = new Flickity(this.ref.slider, {
            prevNextButtons: false,
            pageDots: false,
            groupCells: '100%',
            contain: true,
            ...this.options
        })

        this.flickity.on('select', this.handleFlickitySelect)

        this.ref.prevs.forEach(prev => {
            prev.tabIndex = -1
            prev.addEventListener('click', this.handlePrevClick)
        })
        this.ref.nexts.forEach(next => {
            next.tabIndex = -1
            next.addEventListener('click', this.handleNextClick)
        })

        this.ref.fcktySlider = this.ref.slider.querySelector('.flickity-slider')

        if (this.index === null) {
            this.index = 0
        }
        this.select(this.index)

        this.checkPrevNext()
        this.element.classList.add(STATES.FLICKITY_ACTIVE)
    }

    destroyFlickity() {
        if (!this.flickity) {
            return
        }
        this.ref.fcktySlider = null
        this.flickity.destroy()
        this.flickity = null
        // this.index = null
        this.ref.prevs.forEach(prev => prev.removeEventListener('click', this.handlePrevClick))
        this.ref.nexts.forEach(prev => prev.removeEventListener('click', this.handleNextClick))
        this.element.classList.remove(STATES.FLICKITY_ACTIVE)
        this.element.classList.remove(STATES.IS_PREV_VISIBLE)
        this.element.classList.remove(STATES.IS_NEXT_VISIBLE)
    }

    handlePrevClick = () => {
        this.selectPrev()
    }

    handleNextClick = () => {
        this.selectNext()
    }

    resize() {
        this.destroyFlickity()
        this.resizeEnd()
    }

    select(index) {
        if (this.index === index || index === null) {
            return
        }

        this.index = index
        if (this.flickity) {
            this.flickity.select(index)
        }
    }

    selectPrev() {
        this.flickity.previous()
    }

    selectNext() {
        this.flickity.next()
    }

    checkPrevNext() {
        const count = this.flickity.slides.length

        if (this.index === count - 1 && !this.options.wrapAround) {
            this.element.classList.remove(STATES.IS_NEXT_VISIBLE)
        } else {
            this.element.classList.add(STATES.IS_NEXT_VISIBLE)
        }

        if (this.index === 0 && !this.options.wrapAround) {
            this.element.classList.remove(STATES.IS_PREV_VISIBLE)
        } else {
            this.element.classList.add(STATES.IS_PREV_VISIBLE)
        }
    }
}